import React from "react";
import ReactDOM from "react-dom/client";
import { MantineProvider, Global } from "@mantine/core";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      primaryColor: "cyan",
      colors: {
        cyan: [
          "#e0f2fe",
          "#bae6fd",
          "#7dd3fc",
          "#38bdf8",
          "#0ea5e9",
          "#0284c7", // main
          "#0369a1",
          "#075985",
          "#0c4a6e",
          "#082f49",
        ],
      },
    }}
  >
    {/* Set global styles including body background */}
    <Global
      styles={{
        body: {
          backgroundColor: "#ffffff", // Light gray background (change as you like)
        },
      }}
    />

    <Provider store={store}>
      <App />
    </Provider>
  </MantineProvider>
);
